import { HubMediaCard } from '@/components/Hub/HubMediaCard';
import { trackingAttributes } from '@/lib/heap/trackingAttributes';
import 'material-symbols';

export interface HubChallengeCardProps {
    slug: string;
    title: string;
    url: string;
    description?: string | null;
    imageUrl?: string;
}

export const HubChallengeCard = ({ slug, title, url, description, imageUrl }: HubChallengeCardProps) => (
    <HubMediaCard
        title={title}
        description={description}
        imageUrl={imageUrl}
        action={(
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Learn more about ${title}, opens in a new tab`}
                {...trackingAttributes({
                    click: 'Challenge Learn More Clicked',
                    location: 'hub-sheet',
                    buttonName: 'hub-challenge-learn-more',
                })}
                data-track-challenge-slug={slug}
            >
                Learn more
                <span className="material-symbols-rounded text-lg leading-none" aria-hidden>open_in_new</span>
            </a>
        )}
    />
);
